import { Field, Form, Formik } from "formik";
import * as yup from "yup";
import { spacings } from "../../assets/themes";
import polyglot from "../../utils/polyglot";
import Alert from "@/components/alert";
import Button from "@/components/button";
import FormControl from "@/components/form-control";
import Input from "@/components/input";
import Modal from "@/components/modal";
import { ALERT } from "@/components/styles/variants/alert";
import SelectZipCode from "./select-zip-code";

const ManualAddress = ({ onSubmit, onClose, onBack, status }) => (
  <Formik
    initialValues={{
      address_name: "",
      city_id: "",
      zip_name: "",
      location: [],
    }}
    onSubmit={onSubmit}
    validateOnMount
    validationSchema={yup.object().shape({
      address_name: yup.string().required(),
      city_id: yup.string().required(),
    })}
  >
    {({ isValid, handleSubmit, values, setValues }) => (
      <Form>
        <Modal.Item.Header
          onBack={onBack}
          onClose={onClose}
          title={polyglot.t("common.add_manual_address")}
        />
        <div className="d-flex flex-column flex-fill px-3">
          {status && (
            <Alert.Low
              css={`
                margin-bottom: ${spacings.s};
              `}
              kind={ALERT.KIND.DANGER}
            >
              {status}
            </Alert.Low>
          )}
          <FormControl label={polyglot.t("common.complete_address")}>
            <Field name="address_name">
              {({ field }) => (
                <Input
                  autoComplete="address"
                  autoFocus
                  placeholder={polyglot.t("common.placeholder.num_and_address_name")}
                  {...field}
                />
              )}
            </Field>
          </FormControl>
          <FormControl label={polyglot.t("common.zipcode")}>
            <SelectZipCode
              name="city_id"
              onChange={({ value, label, location = [] }) => {
                const latitude = location[0];
                const longitude = location[1];
                setValues({
                  ...values,
                  zip_name: label,
                  city_id: value,
                  location: location ? { latitude, longitude } : null,
                });
              }}
            />
          </FormControl>
          <Button.Large block className="mt-auto" disabled={!isValid} onClick={handleSubmit}>
            {polyglot.t("common.save")}
          </Button.Large>
        </div>
      </Form>
    )}
  </Formik>
);

export default ManualAddress;
